/**
 * Shared Tailwind class strings for Nut Sheet row inputs.
 *
 * High-contrast by design: border-gray-500 on white meets the WCAG 1.4.11
 * non-text 3:1 contrast minimum (the old border-gray-200 was near-invisible,
 * especially for color-blind operators). `bg-white` keeps inputs legible on
 * the amber trade-column tint. Callers append width overrides (`w-24` etc.).
 */

// Base without a border color so callers (e.g. Actual Gross's red/green
// delivery indicator) can supply their own.
export const cellBase =
  'border rounded text-xs px-1 py-0.5 w-full bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600';

export const textCell = `${cellBase} border-gray-500`;
export const numCell = `${textCell} text-right`;
